import { Box } from "@bca/ui-library";
import { useInView } from "react-intersection-observer";
import { ReactNode } from "react";

const Gradient: React.FC<{
  childImage: ReactNode;
  width?: string;
  height?: string;
}> = ({ childImage, width, height }) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // once the image is loaded we should not execute the code anymore
    rootMargin: "200px 0px", // amount of pixels by which the image is under the viewport before it's fetched
  });

  return (
    <Box
      ref={ref}
      display="inline-block"
      mt="-1px"
      width={width}
      height={height}
      backgroundColor="black"
      css={`
        position: relative;
        z-index: -1;
        border-radius: 5px;
        overflow: hidden;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          display: inline-block;
          background: -moz-linear-gradient(
            top,
            transparent 75%,
            #070b16 95%
          ); /* FF3.6+ */
          background: -webkit-gradient(
            top,
            transparent 75%,
            #070b16 95%
          ); /* Chrome,Safari4+ */
          background: -webkit-linear-gradient(
            top,
            transparent 75%,
            #070b16 95%
          ); /* Chrome10+,Safari5.1+ */
        }
      `}
    >
      {inView && childImage}
    </Box>
  );
};

export default Gradient;
